import { Flex } from '@common/components/Flex';
import * as React from 'react';
import { I18n } from 'react-redux-i18n';
import { DropdownOptionsProps, useDropdownOptionsController } from './dropdown-options.controller';
import { Switch } from '@common/components/switch';
import { getTestAttributes } from '@common/utils/tests';
import { MODULE_NAME } from '@modules/fhq-design-tool/constants/shared';
import cx from 'classnames';
import { QuestionnaireFieldOptionListLocalDto } from '@modules/fhq-design-tool/dto/field-option';
import { DraggableList, DraggableListProps } from '@common/components/draggable-list';
import { Ellipsis } from '@common/components/Ellipsis';

import './dropdown-options.styles.scss';


// Removed a lot of functionality in the scope of https://bitbucket.org/ambrygen/progenyweb/pull-requests/2400/diff


export const DropdownOptions: React.FC<DropdownOptionsProps> = (props) => {
  const {
    handleRowClick,
    handleDisplayChange,
    selectOptionId,
  } = useDropdownOptionsController(props);
  const { data, className, disabled, onChange } = props;

  const renderDisplayValueLabel = React.useCallback((opt: QuestionnaireFieldOptionListLocalDto) => {
    return (
      <Ellipsis text={opt.displayValue?.toString() ?? ''} />
    );
  }, []);

  const renderDisplaySwitch = React.useCallback((opt: QuestionnaireFieldOptionListLocalDto, rowIndex: number) => {
    return (
      <Switch
        {...getTestAttributes(MODULE_NAME, 'display-in-fhq', 'switch', rowIndex)}
        data-id={opt.id}
        checked={opt.displayInFHQ}
        onChange={handleDisplayChange}
      />
    );
  }, [handleDisplayChange]);

  const renderDropdownValue = React.useCallback((opt: QuestionnaireFieldOptionListLocalDto) => {
    return <Ellipsis text={opt.dropdownValue} />
  }, []);

  const columns = React.useMemo(() => {
    return [
      {
        width: '40%',
        id: 'drop-val',
        header: I18n.t('Dropdown Value'),
        render: renderDropdownValue,
      },
      {
        width: '40%',
        id: 'fhq-display-val',
        header: I18n.t('FHQ Display Value'),
        render: renderDisplayValueLabel,
      },
      {
        width: '20%',
        id: 'display',
        header: I18n.t('Display in FHQ'),
        render: renderDisplaySwitch,
      },
    ];
  }, [renderDropdownValue, renderDisplayValueLabel, renderDisplaySwitch]);

  const renderItem = React.useCallback((option: QuestionnaireFieldOptionListLocalDto) => {
    return (
      <Flex
        onClick={handleRowClick}
        data-id={option.id}
        className={cx("FhqDesignToolQuestionnaireDesignerFieldOptions__row", {
          "FhqDesignToolQuestionnaireDesignerFieldOptions__row--selected":
            selectOptionId?.toString() === option.id.toString(),
        })}
        key={option.id}
      >
        {columns.map((column, rowIndex) => (
          <span
            style={{ width: column.width }}
            key={column.id}
            className="FhqDesignToolQuestionnaireDesignerFieldOptions__row__cell"
          >
            {column.render(option, rowIndex)}
          </span>
        ))}
      </Flex>
    );
  }, [handleRowClick, columns, selectOptionId]);

  return (
    <Flex alignItems="flex-start" className={cx("FhqDesignToolQuestionnaireDesignerFieldOptions", { 'FhqDesignToolQuestionnaireDesignerFieldOptions--disabled': disabled },  className)}>
      <div className="FhqDesignToolQuestionnaireDesignerFieldOptions__table">
        <Flex alignItems="center" className="FhqDesignToolQuestionnaireDesignerFieldOptions__header">
          {columns.map((x) => (
            <span 
              style={{ width: x.width }} 
              key={x.id} 
              className="FhqDesignToolQuestionnaireDesignerFieldOptions__header__cell"
            >
              {x.header}
            </span>
          ))}
        </Flex>
        <div>
        <DraggableList
          items={data}
          renderItem={renderItem as DraggableListProps['renderItem']}
          onChange={onChange as DraggableListProps['onChange']}
        />
        </div>
      </div>
    </Flex>
  );
};